import styled from "@emotion/styled";
import { Box } from "@mui/material";
import l10n from "../lib/l10n";
import useTotals from "../hooks/use-totals";

const StyledContainer = styled(Box)`
  font-weight: 400;
  display: inline-block;
  margin-left: 0.35rem;
  font-size: 0.85em;
`;

function SquareMeters() {
  const totals = useTotals();
  return (
    <StyledContainer>
      {totals.getSquareMeters(true)}{l10n.sqmt_symbol}
    </StyledContainer>
  );
}

export default SquareMeters;